// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
// import Navbar from '../../../../Shared/AdminNavbar/Navbar';

// const AddProductForm = () => {

//   const [collapsed, setCollapsed] = React.useState(false);
//   const [mainCategories, setMainCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [products, setProducts] = useState([]);

//   const [productDetails, setProductDetails] = useState({
//     main_category: '',
//     sub_category: '',
//     selected_product: '', // Store only product_id
//     size: '',
//     listprice: '',
//     moq: '',
//     hsncode: '',
//     batch: ''
//   });

//   const [addedProducts, setAddedProducts] = useState([]);

//   // Modal states
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
//   const [showProductModal, setShowProductModal] = useState(false);

//   const [newMainCategory, setNewMainCategory] = useState('');
//   const [newSubCategory, setNewSubCategory] = useState('');
//   const [newProduct, setNewProduct] = useState('');

//   // Fetch main categories
//   useEffect(() => {
//     axios.get('http://localhost:5000/api/main-categories')
//       .then(response => setMainCategories(response.data))
//       .catch(error => console.error("Error fetching main categories", error));
//   }, []);

//   // Fetch subcategories based on selected main category
//   useEffect(() => {
//     if (productDetails.main_category) {
//       axios.get(`http://localhost:5000/api/sub-categories/${productDetails.main_category}`)
//         .then(response => setSubCategories(response.data))
//         .catch(error => console.error("Error fetching subcategories", error));
//     }
//   }, [productDetails.main_category]);

//   // Fetch products based on selected subcategory
//   useEffect(() => {
//     if (productDetails.sub_category) {
//       axios.get(`http://localhost:5000/api/products/${productDetails.sub_category}`)
//         .then(response => setProducts(response.data))
//         .catch(error => console.error("Error fetching products", error));
//     }
//   }, [productDetails.sub_category]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setProductDetails(prevDetails => ({
//       ...prevDetails,
//       [name]: value
//     }));
//   };

//   // Handle category, subcategory, and product creation
//   const handleCategorySubmit = (e) => {
//     e.preventDefault();
//     axios.post('http://localhost:5000/api/main-categories', { maincategory_name: newMainCategory })
//       .then(response => {
//         setMainCategories([...mainCategories, response.data]);
//         setNewMainCategory('');
//         setShowCategoryModal(false);
//       })
//       .catch(error => console.error("Error adding main category", error));
//   };

//   const handleSubCategorySubmit = (e) => {
//     e.preventDefault();
//     axios.post('http://localhost:5000/api/sub-categories', {
//       subcategory_name: newSubCategory,
//       maincategory_id: productDetails.main_category
//     })
//       .then(response => {
//         setSubCategories([...subCategories, response.data]);
//         setNewSubCategory('');
//         setShowSubCategoryModal(false);
//       })
//       .catch(error => console.error("Error adding subcategory", error));
//   };

//   const handleProductNameSubmit = (e) => {
//     e.preventDefault();
//     if (!productDetails.sub_category) {
//       alert("Please select a subcategory before adding a product.");
//       return;
//     }
//     axios.post('http://localhost:5000/api/product-name', {
//       product_name: newProduct,
//       subcategory_id: productDetails.sub_category
//     })
//       .then(response => {
//         setProducts([...products, {
//           product_id: response.data.product_id,
//           product_name: response.data.product_name,
//           subcategory_id: response.data.subcategory_id
//         }]);
//         setNewProduct('');
//         setShowProductModal(false);
//         alert("Product name added successfully");
//       })
//       .catch(error => console.error("Error adding product name", error));
//   };

//   // Add product batch
//   const handleAddBatch = () => {
//     const currentProduct = { ...productDetails };

//     // Validate that all fields are filled
//     if (!currentProduct.selected_product || !currentProduct.main_category || !currentProduct.sub_category) {
//       alert("Please select a product, category, and subcategory.");
//       return;
//     }

//     // Add the current product batch to the list
//     const updatedProducts = [...addedProducts, currentProduct];
//     setAddedProducts(updatedProducts);

//     // Store it temporarily in localStorage
//     localStorage.setItem('product_batches', JSON.stringify(updatedProducts));

//     // Reset only the input fields, not the dropdowns (keep dropdowns unchanged)
//     setProductDetails(prevDetails => ({
//       ...prevDetails,
//       size: '',
//       listprice: '',
//       moq: '',
//       hsncode: '',
//       batch: ''
//     }));
//   };

//   // Handle submit
//   const handleSubmit = () => {
//     if (addedProducts.length === 0) {
//       alert("Please add at least one product batch.");
//       return;
//     }

//     // Send all the added products to the backend
//     axios.post('http://localhost:5000/api/products', addedProducts)
//       .then(response => {
//         alert("Products added successfully.");
//         // Clear the local storage and reset state
//         localStorage.removeItem('product_batches');
//         setAddedProducts([]);
//       })
//       .catch(error => {
//         console.error("Error adding products", error);
//         alert("Failed to add products: " + (error.response?.data?.error || error.message));
//       });
//   };

//   // Remove a product batch from the added list
//   const handleRemoveBatch = (index) => {
//     const updatedList = addedProducts.filter((_, i) => i !== index);
//     setAddedProducts(updatedList);
//     localStorage.setItem('product_batches', JSON.stringify(updatedList));
//   };

//   return (
//     <div className="CollapseContainer">
//       <Navbar onToggleSidebar={setCollapsed} />
//       <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
//         <div className='card p-4'>
//     <div className="container">
//       <h2 className="my-4">Add Product</h2>
//       <Form>
//         <Row className="mb-3">
//           <Col md={3}>
//             <Form.Group controlId="mainCategory">
//               <Form.Label>Main Category</Form.Label>
//               <Form.Control as="select" name="main_category" value={productDetails.main_category} onChange={handleInputChange} required>
//                 <option value="">Select Main Category</option>
//                 {mainCategories.map(category => (
//                   <option key={category.maincategory_id} value={category.maincategory_id}>
//                     {category.maincategory_name}
//                   </option>
//                 ))}
//               </Form.Control>
//             </Form.Group>
//           </Col>
//           <Col md={3}>
//             <Button variant="link" onClick={() => setShowCategoryModal(true)}>+ Add</Button>
//           </Col>

//           <Col md={3}>
//             <Form.Group controlId="subCategory">
//               <Form.Label>Sub Category</Form.Label>
//               <Form.Control as="select" name="sub_category" value={productDetails.sub_category} onChange={handleInputChange} required>
//                 <option value="">Select Sub Category</option>
//                 {subCategories.map(subCategory => (
//                   <option key={subCategory.subcategory_id} value={subCategory.subcategory_id}>
//                     {subCategory.subcategory_name}
//                   </option>
//                 ))}
//               </Form.Control>
//             </Form.Group>
//           </Col>
//           <Col md={3}>
//             <Button variant="link" onClick={() => setShowSubCategoryModal(true)}>+ Add</Button>
//           </Col>

//           <Col md={3}>
//             <Form.Group controlId="productName">
//               <Form.Label>Product</Form.Label>
//               <Form.Control as="select" name="selected_product" value={productDetails.selected_product} onChange={handleInputChange} required>
//                 <option value="">Select Product</option>
//                 {products.map(product => (
//                   <option key={product.product_id} value={product.product_id}>
//                     {product.product_name}
//                   </option>
//                 ))}
//               </Form.Control>
//             </Form.Group>
//           </Col>
//           <Col md={3}>
//             <Button variant="link" onClick={() => setShowProductModal(true)}>+ Add</Button>
//           </Col>
//         </Row>

//         {/* Input fields for size, hsncode, listprice, etc. */}
//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Group controlId="size">
//               <Form.Label>Size</Form.Label>
//               <Form.Control type="text" name="size" value={productDetails.size} onChange={handleInputChange} required />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group controlId="hsncode">
//               <Form.Label>HSN Code</Form.Label>
//               <Form.Control type="text" name="hsncode" value={productDetails.hsncode} onChange={handleInputChange} required />
//             </Form.Group>
//           </Col>
//         </Row>
//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Group controlId="listprice">
//               <Form.Label>List Price</Form.Label>
//               <Form.Control type="number" name="listprice" value={productDetails.listprice} onChange={handleInputChange} required />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group controlId="moq">
//               <Form.Label>MOQ</Form.Label>
//               <Form.Control type="number" name="moq" value={productDetails.moq} onChange={handleInputChange} required />
//             </Form.Group>
//           </Col>
//         </Row>
//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Group controlId="batch">
//               <Form.Label>Batch</Form.Label>
//               <Form.Control type="text" name="batch" value={productDetails.batch} onChange={handleInputChange} required />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Button variant="primary" onClick={handleAddBatch}>Add Batch</Button>
//         <Button variant="primary" onClick={handleSubmit}>Submit All Products</Button>
//       </Form>

//       {/* Modal for Adding Category */}
//       <Modal show={showCategoryModal} onHide={() => setShowCategoryModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Add New Main Category</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleCategorySubmit}>
//             <Form.Group controlId="newMainCategory">
//               <Form.Label>Category Name</Form.Label>
//               <Form.Control type="text" value={newMainCategory} onChange={(e) => setNewMainCategory(e.target.value)} required />
//             </Form.Group>
//             <Button variant="primary" type="submit">Submit</Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Modal for Adding Subcategory */}
//       <Modal show={showSubCategoryModal} onHide={() => setShowSubCategoryModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Add New Sub Category</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubCategorySubmit}>
//             <Form.Group controlId="newSubCategory">
//               <Form.Label>Sub Category Name</Form.Label>
//               <Form.Control type="text" value={newSubCategory} onChange={(e) => setNewSubCategory(e.target.value)} required />
//             </Form.Group>
//             <Button variant="primary" type="submit">Submit</Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Modal for Adding Product */}
//       <Modal show={showProductModal} onHide={() => setShowProductModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Add New Product</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleProductNameSubmit}>
//             <Form.Group controlId="newProduct">
//               <Form.Label>Product Name</Form.Label>
//               <Form.Control type="text" value={newProduct} onChange={(e) => setNewProduct(e.target.value)} required />
//             </Form.Group>
//             <Button variant="primary" type="submit">Submit</Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Display Added Products */}
//       <h4 className="my-4">Added Products</h4>
//       <table className="table table-bordered">
//         <thead>
//           <tr>
//             <th>Product</th>
//             <th>Batch</th>
//             <th>Size</th>
//             <th>Price</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {addedProducts.map((product, index) => (
//             <tr key={index}>
//               <td>{product.selected_product}</td>
//               <td>{product.batch}</td>
//               <td>{product.size}</td>
//               <td>{product.listprice}</td>
//               <td>
//                 <Button variant="danger" onClick={() => handleRemoveBatch(index)}>Remove</Button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//     </div>
//     </div>
//     </div>
//   );
// };

// export default AddProductForm;




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
// import Navbar from '../../../../Shared/AdminNavbar/Navbar';

// const AddProductForm = () => {
//   const [collapsed, setCollapsed] = React.useState(false);
//   const [companies, setCompanies] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [units, setUnits] = useState(['UNT-UNITS']); // Default unit
//   const [productDetails, setProductDetails] = useState({
//     productName: '',
//     companyName: '',
//     price: '',
//     inclusiveGST: false,
//     gstRate: '18%', // Default GST rate
//     unit: 'UNT-UNITS',
//     sku: '',
//     openingStock: '',
//     openingStockDate: '',
//     minStockAlert: '',
//     maxStockAlert: '',
//     cessRate: '',
//     cessAmount: '',
//     hsnCode: '',
//     canBeSold: false,
//     maintainBatch: false,
//     description: '',
//     batches: [{ batchNo: '', expDate: '', mfgDate: '', salePrice: '', purchasePrice: '', mrp: '', batchPrice: '', stock: '' }]
//   });

//   const [addedBatches, setAddedBatches] = useState([]);

//   useEffect(() => {
//     // Mock data for companies and categories (replace with API calls if needed)
//     setCompanies(['Company A', 'Company B']);
//     setCategories(['Category 1', 'Category 2']);
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setProductDetails(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleBatchChange = (index, e) => {
//     const { name, value } = e.target;
//     const newBatches = [...productDetails.batches];
//     newBatches[index][name] = value;
//     setProductDetails(prev => ({ ...prev, batches: newBatches }));
//   };

//   const handleAddBatch = () => {
//     if (productDetails.batches.some(batch => !batch.batchNo || !batch.salePrice || !batch.stock)) {
//       alert("Please fill all required batch fields.");
//       return;
//     }
//     setAddedBatches([...addedBatches, ...productDetails.batches]);
//     setProductDetails(prev => ({
//       ...prev,
//       batches: [{ batchNo: '', expDate: '', mfgDate: '', salePrice: '', purchasePrice: '', mrp: '', batchPrice: '', stock: '' }]
//     }));
//   };

//   const handleRemoveBatch = (index) => {
//     const updatedBatches = addedBatches.filter((_, i) => i !== index);
//     setAddedBatches(updatedBatches);
//   };

//   const handleSubmit = () => {
//     if (addedBatches.length === 0) {
//       alert("Please add at least one batch.");
//       return;
//     }
//     console.log("Submitting:", { ...productDetails, batches: addedBatches });
//     // Add API call here
//     alert("Product added successfully.");
//     setAddedBatches([]);
//     setProductDetails(prev => ({
//       ...prev,
//       batches: [{ batchNo: '', expDate: '', mfgDate: '', salePrice: '', purchasePrice: '', mrp: '', batchPrice: '', stock: '' }]
//     }));
//   };

//   return (
//     <div className="CollapseContainer">
//       <Navbar onToggleSidebar={setCollapsed} />
//       <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
//         <div className="card p-4">
//           <div className="container">
//             <h2 className="my-4">Add Product to Purchased Items</h2>
//             <Form>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="productName">
//                     <Form.Label>Product Name</Form.Label>
//                     <Form.Control type="text" name="productName" value={productDetails.productName} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="category">
//                     <Form.Label>Select Category</Form.Label>
//                     <Form.Control as="select" name="category" value={productDetails.category} onChange={handleInputChange}>
//                       <option value="">Select Category</option>
//                       {categories.map(cat => <option key={cat}>{cat}</option>)}
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="companyName">
//                     <Form.Label>Company Name</Form.Label>
//                     <Form.Control as="select" name="companyName" value={productDetails.companyName} onChange={handleInputChange}>
//                       <option value="">Select Company</option>
//                       {companies.map(co => <option key={co}>{co}</option>)}
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="price">
//                     <Form.Label>Price</Form.Label>
//                     <Form.Control type="number" name="price" value={productDetails.price} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="inclusiveGST">
//                     <Form.Label>Inclusive of GST</Form.Label>
//                     <Form.Control as="select" name="inclusiveGST" value={productDetails.inclusiveGST} onChange={handleInputChange}>
//                       <option value={false}>No</option>
//                       <option value={true}>Yes</option>
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="gstRate">
//                     <Form.Label>GST Rate</Form.Label>
//                     <Form.Control as="select" name="gstRate" value={productDetails.gstRate} onChange={handleInputChange}>
//                       <option value="18%">18%</option>
//                       <option value="Non Taxable">Non Taxable</option>
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="netPriceGST">
//                     <Form.Label>Net Price | GST</Form.Label>
//                     <Form.Control type="text" name="netPriceGST" value={productDetails.netPriceGST} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="hsnCode">
//                     <Form.Label>HSN Code</Form.Label>
//                     <Form.Control type="text" name="hsnCode" value={productDetails.hsnCode} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="unit">
//                     <Form.Label>Unit</Form.Label>
//                     <Form.Control as="select" name="unit" value={productDetails.unit} onChange={handleInputChange}>
//                       {units.map(unit => <option key={unit}>{unit}</option>)}
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="cessRate">
//                     <Form.Label>CESS Rate%</Form.Label>
//                     <Form.Control type="text" name="cessRate" value={productDetails.cessRate} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="cessAmount">
//                     <Form.Label>CESS Amount</Form.Label>
//                     <Form.Control type="text" name="cessAmount" value={productDetails.cessAmount} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="sku">
//                     <Form.Label>SKU</Form.Label>
//                     <Form.Control type="text" name="sku" value={productDetails.sku} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="openingStock">
//                     <Form.Label>Opening Stock</Form.Label>
//                     <Form.Control type="number" name="openingStock" value={productDetails.openingStock} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="openingStockDate">
//                     <Form.Label>Opening Stock Date</Form.Label>
//                     <Form.Control type="date" name="openingStockDate" value={productDetails.openingStockDate} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="minStockAlert">
//                     <Form.Label>Min Stock Alert</Form.Label>
//                     <Form.Control type="number" name="minStockAlert" value={productDetails.minStockAlert} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="maxStockAlert">
//                     <Form.Label>Max Stock Alert</Form.Label>
//                     <Form.Control type="number" name="maxStockAlert" value={productDetails.maxStockAlert} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="canBeSold">
//                     <Form.Label>Can be Sold</Form.Label>
//                     <Form.Check type="checkbox" name="canBeSold" checked={productDetails.canBeSold} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="maintainBatch">
//                     <Form.Label>Maintain Batch</Form.Label>
//                     <Form.Check type="checkbox" name="maintainBatch" checked={productDetails.maintainBatch} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <Form.Group controlId="description">
//                     <Form.Label>Description</Form.Label>
//                     <Form.Control as="textarea" name="description" value={productDetails.description} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <h4>Batch Details</h4>
//               {productDetails.batches.map((batch, index) => (
//                 <Row key={index} className="mb-3">
//                   <Col md={2}>
//                     <Form.Group controlId={`batchNo${index}`}>
//                       <Form.Label>Batch No.*</Form.Label>
//                       <Form.Control type="text" name="batchNo" value={batch.batchNo} onChange={(e) => handleBatchChange(index, e)} required />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`expDate${index}`}>
//                       <Form.Label>Exp. Date</Form.Label>
//                       <Form.Control type="date" name="expDate" value={batch.expDate} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`mfgDate${index}`}>
//                       <Form.Label>Mfg. Date</Form.Label>
//                       <Form.Control type="date" name="mfgDate" value={batch.mfgDate} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`salePrice${index}`}>
//                       <Form.Label>Sale Price*</Form.Label>
//                       <Form.Control type="number" name="salePrice" value={batch.salePrice} onChange={(e) => handleBatchChange(index, e)} required />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`purchasePrice${index}`}>
//                       <Form.Label>Purchase Price</Form.Label>
//                       <Form.Control type="number" name="purchasePrice" value={batch.purchasePrice} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`mrp${index}`}>
//                       <Form.Label>M.R.P</Form.Label>
//                       <Form.Control type="number" name="mrp" value={batch.mrp} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`batchPrice${index}`}>
//                       <Form.Label>Batch Price</Form.Label>
//                       <Form.Control type="number" name="batchPrice" value={batch.batchPrice} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`stock${index}`}>
//                       <Form.Label>Stock*</Form.Label>
//                       <Form.Control type="number" name="stock" value={batch.stock} onChange={(e) => handleBatchChange(index, e)} required />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Button variant="danger" onClick={() => {
//                       const newBatches = [...productDetails.batches];
//                       newBatches.splice(index, 1);
//                       setProductDetails(prev => ({ ...prev, batches: newBatches }));
//                     }} className="mt-4">Remove</Button>
//                   </Col>
//                 </Row>
//               ))}
//               <Button variant="primary" onClick={handleAddBatch} className="mb-3">Add Batch</Button>
//               <div className="d-flex justify-content-end">
//                 <Button variant="secondary" onClick={() => {}}>Close</Button>
//                 <Button variant="primary" onClick={handleSubmit} class="ms-2">Submit</Button>
//               </div>
//               {addedBatches.length > 0 && (
//                 <div className="mt-4">
//                   <h4>Added Batches</h4>
//                   <table className="table table-bordered">
//                     <thead>
//                       <tr>
//                         <th>Batch No.</th>
//                         <th>Exp. Date</th>
//                         <th>Mfg. Date</th>
//                         <th>Sale Price</th>
//                         <th>Purchase Price</th>
//                         <th>M.R.P</th>
//                         <th>Batch Price</th>
//                         <th>Stock</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {addedBatches.map((batch, index) => (
//                         <tr key={index}>
//                           <td>{batch.batchNo}</td>
//                           <td>{batch.expDate}</td>
//                           <td>{batch.mfgDate}</td>
//                           <td>{batch.salePrice}</td>
//                           <td>{batch.purchasePrice}</td>
//                           <td>{batch.mrp}</td>
//                           <td>{batch.batchPrice}</td>
//                           <td>{batch.stock}</td>
//                           <td><Button variant="danger" onClick={() => handleRemoveBatch(index)}>Remove</Button></td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </Form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddProductForm;




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
// import Navbar from '../../../../Shared/AdminNavbar/Navbar';

// const AddProductForm = () => {
//   const [collapsed, setCollapsed] = React.useState(false);
//   const [mainCategories, setMainCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [companies, setCompanies] = useState([]);

//   const [productDetails, setProductDetails] = useState({
//     productName: '',
//     companyName: '',
//     price: '',
//     inclusiveGST: false,
//     gstRate: '18%',
//     unit: 'UNT-UNITS',
//     sku: '',
//     openingStock: '',
//     openingStockDate: '',
//     minStockAlert: '',
//     maxStockAlert: '',
//     cessRate: '',
//     cessAmount: '',
//     hsnCode: '',
//     canBeSold: false,
//     maintainBatch: false,
//     description: '',
//     batches: [{ batchNo: '', expDate: '', mfgDate: '', salePrice: '', purchasePrice: '', mrp: '', batchPrice: '', stock: '' }]
//   });

//   const [addedBatches, setAddedBatches] = useState([]);

//   // Modal states
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
//   const [showProductModal, setShowProductModal] = useState(false);

//   const [newMainCategory, setNewMainCategory] = useState('');
//   const [newSubCategory, setNewSubCategory] = useState('');
//   const [newProduct, setNewProduct] = useState('');

//   useEffect(() => {
//     // Fetch main categories
//     axios.get('http://localhost:5000/api/main-categories')
//       .then(response => setMainCategories(response.data))
//       .catch(error => console.error("Error fetching main categories", error));

//     // Mock data for companies (replace with API call if needed)
//     setCompanies(['Company A', 'Company B']);
//   }, []);

//   useEffect(() => {
//     if (productDetails.main_category) {
//       axios.get(`http://localhost:5000/api/sub-categories/${productDetails.main_category}`)
//         .then(response => setSubCategories(response.data))
//         .catch(error => console.error("Error fetching subcategories", error));
//     }
//   }, [productDetails.main_category]);

//   useEffect(() => {
//     if (productDetails.sub_category) {
//       axios.get(`http://localhost:5000/api/products/${productDetails.sub_category}`)
//         .then(response => setProducts(response.data))
//         .catch(error => console.error("Error fetching products", error));
//     }
//   }, [productDetails.sub_category]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setProductDetails(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleBatchChange = (index, e) => {
//     const { name, value } = e.target;
//     const newBatches = [...productDetails.batches];
//     newBatches[index][name] = value;
//     setProductDetails(prev => ({ ...prev, batches: newBatches }));
//   };

//   const handleCategorySubmit = (e) => {
//     e.preventDefault();
//     axios.post('http://localhost:5000/api/main-categories', { maincategory_name: newMainCategory })
//       .then(response => {
//         setMainCategories([...mainCategories, response.data]);
//         setNewMainCategory('');
//         setShowCategoryModal(false);
//       })
//       .catch(error => console.error("Error adding main category", error));
//   };

//   const handleSubCategorySubmit = (e) => {
//     e.preventDefault();
//     axios.post('http://localhost:5000/api/sub-categories', {
//       subcategory_name: newSubCategory,
//       maincategory_id: productDetails.main_category
//     })
//       .then(response => {
//         setSubCategories([...subCategories, response.data]);
//         setNewSubCategory('');
//         setShowSubCategoryModal(false);
//       })
//       .catch(error => console.error("Error adding subcategory", error));
//   };

//   const handleProductNameSubmit = (e) => {
//     e.preventDefault();
//     if (!productDetails.sub_category) {
//       alert("Please select a subcategory before adding a product.");
//       return;
//     }
//     axios.post('http://localhost:5000/api/product-name', {
//       product_name: newProduct,
//       subcategory_id: productDetails.sub_category
//     })
//       .then(response => {
//         setProducts([...products, {
//           product_id: response.data.product_id,
//           product_name: response.data.product_name,
//           subcategory_id: response.data.subcategory_id
//         }]);
//         setNewProduct('');
//         setShowProductModal(false);
//         alert("Product name added successfully");
//       })
//       .catch(error => console.error("Error adding product name", error));
//   };

//   const handleAddBatch = () => {
//     if (productDetails.batches.some(batch => !batch.batchNo || !batch.salePrice || !batch.stock)) {
//       alert("Please fill all required batch fields.");
//       return;
//     }
//     setAddedBatches([...addedBatches, ...productDetails.batches]);
//     setProductDetails(prev => ({
//       ...prev,
//       batches: [{ batchNo: '', expDate: '', mfgDate: '', salePrice: '', purchasePrice: '', mrp: '', batchPrice: '', stock: '' }]
//     }));
//   };

//   const handleRemoveBatch = (index) => {
//     const updatedBatches = addedBatches.filter((_, i) => i !== index);
//     setAddedBatches(updatedBatches);
//   };

//   const handleSubmit = () => {
//     if (addedBatches.length === 0) {
//       alert("Please add at least one batch.");
//       return;
//     }
//     axios.post('http://localhost:5000/api/products', { ...productDetails, batches: addedBatches })
//       .then(response => {
//         alert("Products added successfully.");
//         setAddedBatches([]);
//         setProductDetails(prev => ({
//           ...prev,
//           batches: [{ batchNo: '', expDate: '', mfgDate: '', salePrice: '', purchasePrice: '', mrp: '', batchPrice: '', stock: '' }]
//         }));
//       })
//       .catch(error => {
//         console.error("Error adding products", error);
//         alert("Failed to add products: " + (error.response?.data?.error || error.message));
//       });
//   };

//   return (
//     <div className="CollapseContainer">
//       <Navbar onToggleSidebar={setCollapsed} />
//       <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
//         <div className="card p-4">
//           <div className="container">
//             <h2 className="my-4">Add Product to Purchased Items</h2>
//             <Form>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="productName">
//                     <Form.Label>Product Name</Form.Label>
//                     <Form.Control type="text" name="productName" value={productDetails.productName} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="category">
//                     <Form.Label>Select Category</Form.Label>
//                     <Form.Control as="select" name="main_category" value={productDetails.main_category} onChange={handleInputChange}>
//                       <option value="">Select Category</option>
//                       {mainCategories.map(category => (
//                         <option key={category.maincategory_id} value={category.maincategory_id}>
//                           {category.maincategory_name}
//                         </option>
//                       ))}
//                     </Form.Control>
//                   </Form.Group>
//                   <Button variant="link" onClick={() => setShowCategoryModal(true)}>+ Add</Button>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="companyName">
//                     <Form.Label>Company Name</Form.Label>
//                     <Form.Control as="select" name="companyName" value={productDetails.companyName} onChange={handleInputChange}>
//                       <option value="">Select Company</option>
//                       {companies.map(co => <option key={co}>{co}</option>)}
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="price">
//                     <Form.Label>Price</Form.Label>
//                     <Form.Control type="number" name="price" value={productDetails.price} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="inclusiveGST">
//                     <Form.Label>Inclusive of GST</Form.Label>
//                     <Form.Control as="select" name="inclusiveGST" value={productDetails.inclusiveGST} onChange={handleInputChange}>
//                       <option value={false}>No</option>
//                       <option value={true}>Yes</option>
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="gstRate">
//                     <Form.Label>GST Rate</Form.Label>
//                     <Form.Control as="select" name="gstRate" value={productDetails.gstRate} onChange={handleInputChange}>
//                       <option value="18%">18%</option>
//                       <option value="Non Taxable">Non Taxable</option>
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="netPriceGST">
//                     <Form.Label>Net Price | GST</Form.Label>
//                     <Form.Control type="text" name="netPriceGST" value={productDetails.netPriceGST} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="hsnCode">
//                     <Form.Label>HSN Code</Form.Label>
//                     <Form.Control type="text" name="hsnCode" value={productDetails.hsnCode} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="unit">
//                     <Form.Label>Unit</Form.Label>
//                     <Form.Control as="select" name="unit" value={productDetails.unit} onChange={handleInputChange}>
//                       <option value="UNT-UNITS">UNT-UNITS</option>
//                     </Form.Control>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="cessRate">
//                     <Form.Label>CESS Rate%</Form.Label>
//                     <Form.Control type="text" name="cessRate" value={productDetails.cessRate} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="cessAmount">
//                     <Form.Label>CESS Amount</Form.Label>
//                     <Form.Control type="text" name="cessAmount" value={productDetails.cessAmount} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="sku">
//                     <Form.Label>SKU</Form.Label>
//                     <Form.Control type="text" name="sku" value={productDetails.sku} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="openingStock">
//                     <Form.Label>Opening Stock</Form.Label>
//                     <Form.Control type="number" name="openingStock" value={productDetails.openingStock} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="openingStockDate">
//                     <Form.Label>Opening Stock Date</Form.Label>
//                     <Form.Control type="date" name="openingStockDate" value={productDetails.openingStockDate} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="minStockAlert">
//                     <Form.Label>Min Stock Alert</Form.Label>
//                     <Form.Control type="number" name="minStockAlert" value={productDetails.minStockAlert} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={3}>
//                   <Form.Group controlId="maxStockAlert">
//                     <Form.Label>Max Stock Alert</Form.Label>
//                     <Form.Control type="number" name="maxStockAlert" value={productDetails.maxStockAlert} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="canBeSold">
//                     <Form.Label>Can be Sold</Form.Label>
//                     <Form.Check type="checkbox" name="canBeSold" checked={productDetails.canBeSold} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group controlId="maintainBatch">
//                     <Form.Label>Maintain Batch</Form.Label>
//                     <Form.Check type="checkbox" name="maintainBatch" checked={productDetails.maintainBatch} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <Form.Group controlId="description">
//                     <Form.Label>Description</Form.Label>
//                     <Form.Control as="textarea" name="description" value={productDetails.description} onChange={handleInputChange} />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <h4>Batch Details</h4>
//               {productDetails.batches.map((batch, index) => (
//                 <Row key={index} className="mb-3">
//                   <Col md={2}>
//                     <Form.Group controlId={`batchNo${index}`}>
//                       <Form.Label>Batch No.*</Form.Label>
//                       <Form.Control type="text" name="batchNo" value={batch.batchNo} onChange={(e) => handleBatchChange(index, e)} required />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`expDate${index}`}>
//                       <Form.Label>Exp. Date</Form.Label>
//                       <Form.Control type="date" name="expDate" value={batch.expDate} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`mfgDate${index}`}>
//                       <Form.Label>Mfg. Date</Form.Label>
//                       <Form.Control type="date" name="mfgDate" value={batch.mfgDate} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`salePrice${index}`}>
//                       <Form.Label>Sale Price*</Form.Label>
//                       <Form.Control type="number" name="salePrice" value={batch.salePrice} onChange={(e) => handleBatchChange(index, e)} required />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`purchasePrice${index}`}>
//                       <Form.Label>Purchase Price</Form.Label>
//                       <Form.Control type="number" name="purchasePrice" value={batch.purchasePrice} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`mrp${index}`}>
//                       <Form.Label>M.R.P</Form.Label>
//                       <Form.Control type="number" name="mrp" value={batch.mrp} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`batchPrice${index}`}>
//                       <Form.Label>Batch Price</Form.Label>
//                       <Form.Control type="number" name="batchPrice" value={batch.batchPrice} onChange={(e) => handleBatchChange(index, e)} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Form.Group controlId={`stock${index}`}>
//                       <Form.Label>Stock*</Form.Label>
//                       <Form.Control type="number" name="stock" value={batch.stock} onChange={(e) => handleBatchChange(index, e)} required />
//                     </Form.Group>
//                   </Col>
//                   <Col md={2}>
//                     <Button variant="danger" onClick={() => {
//                       const newBatches = [...productDetails.batches];
//                       newBatches.splice(index, 1);
//                       setProductDetails(prev => ({ ...prev, batches: newBatches }));
//                     }} className="mt-4">Remove</Button>
//                   </Col>
//                 </Row>
//               ))}
//               <Button variant="primary" onClick={handleAddBatch} className="mb-3">Add Batch</Button>
//               <div className="d-flex justify-content-end">
//                 <Button variant="secondary" onClick={() => {}}>Close</Button>
//                 <Button variant="primary" onClick={handleSubmit} className="ms-2">Submit</Button>
//               </div>
//               {addedBatches.length > 0 && (
//                 <div className="mt-4">
//                   <h4>Added Batches</h4>
//                   <table className="table table-bordered">
//                     <thead>
//                       <tr>
//                         <th>Batch No.</th>
//                         <th>Exp. Date</th>
//                         <th>Mfg. Date</th>
//                         <th>Sale Price</th>
//                         <th>Purchase Price</th>
//                         <th>M.R.P</th>
//                         <th>Batch Price</th>
//                         <th>Stock</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {addedBatches.map((batch, index) => (
//                         <tr key={index}>
//                           <td>{batch.batchNo}</td>
//                           <td>{batch.expDate}</td>
//                           <td>{batch.mfgDate}</td>
//                           <td>{batch.salePrice}</td>
//                           <td>{batch.purchasePrice}</td>
//                           <td>{batch.mrp}</td>
//                           <td>{batch.batchPrice}</td>
//                           <td>{batch.stock}</td>
//                           <td><Button variant="danger" onClick={() => handleRemoveBatch(index)}>Remove</Button></td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </Form>

//             {/* Modal for Adding Category */}
//             <Modal show={showCategoryModal} onHide={() => setShowCategoryModal(false)}>
//               <Modal.Header closeButton>
//                 <Modal.Title>Add New Main Category</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <Form onSubmit={handleCategorySubmit}>
//                   <Form.Group controlId="newMainCategory">
//                     <Form.Label>Category Name</Form.Label>
//                     <Form.Control type="text" value={newMainCategory} onChange={(e) => setNewMainCategory(e.target.value)} required />
//                   </Form.Group>
//                   <Button variant="primary" type="submit" className="mt-3">Add</Button>
//                 </Form>
//               </Modal.Body>
//             </Modal>

//             {/* Modal for Adding Subcategory */}
//             <Modal show={showSubCategoryModal} onHide={() => setShowSubCategoryModal(false)}>
//               <Modal.Header closeButton>
//                 <Modal.Title>Add New Sub Category</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <Form onSubmit={handleSubCategorySubmit}>
//                   <Form.Group controlId="newSubCategory">
//                     <Form.Label>Sub Category Name</Form.Label>
//                     <Form.Control type="text" value={newSubCategory} onChange={(e) => setNewSubCategory(e.target.value)} required />
//                   </Form.Group>
//                   <Button variant="primary" type="submit" className="mt-3">Add</Button>
//                 </Form>
//               </Modal.Body>
//             </Modal>

//             {/* Modal for Adding Product */}
//             <Modal show={showProductModal} onHide={() => setShowProductModal(false)}>
//               <Modal.Header closeButton>
//                 <Modal.Title>Add New Product</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <Form onSubmit={handleProductNameSubmit}>
//                   <Form.Group controlId="newProduct">
//                     <Form.Label>Product Name</Form.Label>
//                     <Form.Control type="text" value={newProduct} onChange={(e) => setNewProduct(e.target.value)} required />
//                   </Form.Group>
//                   <Button variant="primary" type="submit" className="mt-3">Add</Button>
//                 </Form>
//               </Modal.Body>
//             </Modal>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddProductForm;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Row, Col, Table } from 'react-bootstrap';
import {  Spinner } from "react-bootstrap";
import Navbar from '../../../../Shared/AdminNavbar/Navbar';
import baseURL from '../../../../Apiurs/Apiurls';

const AddProductForm = () => { 
  const [collapsed, setCollapsed] = React.useState(false);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
 const [loading, setLoading] = useState(false);
  const [productDetails, setProductDetails] = useState({
    main_category: '',
    sub_category: '',
    selected_product: '', // Store only product_id
    size: '',
    listprice: '',
    moq: '',
    hsncode: '',
    Quantity: '',
    gstrate: '18%',
    description: '',
    batch: '',
    productImage: null,
    techSpecs: null
  });

  const [addedProducts, setAddedProducts] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null); // Track which product is being edited

  // Modal states
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);

  const [newMainCategory, setNewMainCategory] = useState('');
  const [newSubCategory, setNewSubCategory] = useState('');
  const [newProduct, setNewProduct] = useState('');

  // Fetch main categories
  useEffect(() => {
    axios.get(`${baseURL}/api/main`)
      .then(response => setMainCategories(response.data))
      .catch(error => console.error("Error fetching main categories", error));
  }, []);

  // Fetch subcategories based on selected main category
  useEffect(() => {
    if (productDetails.main_category) {
      axios.get(`${baseURL}/api/sub-categories-main/${productDetails.main_category}`)
        .then(response => setSubCategories(response.data))
        .catch(error => console.error("Error fetching subcategories", error));
    }
  }, [productDetails.main_category]);

  // Fetch products based on selected subcategory
  useEffect(() => {
    if (productDetails.sub_category) {
      axios.get(`${baseURL}/api/products-main/${productDetails.sub_category}`)
        .then(response => setProducts(response.data))
        .catch(error => console.error("Error fetching products", error));
    }
  }, [productDetails.sub_category]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProductDetails(prevDetails => ({
      ...prevDetails,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setProductDetails(prevDetails => ({
      ...prevDetails,
      [name]: files[0]
    }));
  };

  // Handle category, subcategory, and product creation
  const handleCategorySubmit = (e) => {
    e.preventDefault();
    axios.post(`${baseURL}/api/main-categories-main`, { maincategory_name: newMainCategory })
      .then(response => {
        setMainCategories([...mainCategories, response.data]);
        setNewMainCategory('');
        setShowCategoryModal(false);
      })
      .catch(error => console.error("Error adding main category", error));
  };

  const handleSubCategorySubmit = (e) => {
    e.preventDefault();
    axios.post(`${baseURL}/api/sub-categories-main`, {
      subcategory_name: newSubCategory,
      maincategory_id: productDetails.main_category
    })
      .then(response => {
        setSubCategories([...subCategories, response.data]);
        setNewSubCategory('');
        setShowSubCategoryModal(false);
      })
      .catch(error => console.error("Error adding subcategory", error));
  };

  const handleProductNameSubmit = (e) => {
    e.preventDefault();
    if (!productDetails.sub_category) {
      alert("Please select a subcategory before adding a product.");
      return;
    }
    axios.post(`${baseURL}/api/product-name-main`, {
      product_name: newProduct,
      subcategory_id: productDetails.sub_category
    })
      .then(response => {
        setProducts([...products, {
          product_id: response.data.product_id,
          product_name: response.data.product_name,
          subcategory_id: response.data.subcategory_id
        }]);
        setNewProduct('');
        setShowProductModal(false);
        alert("Product name added successfully");
      })
      .catch(error => console.error("Error adding product name", error));
  };

  // Add product batch
  const handleAddBatch = () => {
    const currentProduct = { ...productDetails };

    // Validate that all fields are filled
    if (!currentProduct.selected_product || !currentProduct.main_category || !currentProduct.sub_category) {
      alert("Please select a product, category, and subcategory.");
      return;
    }

    // Find the product name for display
    const selectedProduct = products.find(p => p.product_id === currentProduct.selected_product);
    currentProduct.product_name = selectedProduct ? selectedProduct.product_name : '';

    // If editing, update the existing product
    if (editingIndex !== null) {
      const updatedProducts = [...addedProducts];
      updatedProducts[editingIndex] = currentProduct;
      setAddedProducts(updatedProducts);
      localStorage.setItem('product_batches', JSON.stringify(updatedProducts));
      setEditingIndex(null);
    } else {
      // Add the current product batch to the list
      const updatedProducts = [...addedProducts, currentProduct];
      setAddedProducts(updatedProducts);
      localStorage.setItem('product_batches', JSON.stringify(updatedProducts));
    }

    // Reset the input fields
    setProductDetails({
      main_category: productDetails.main_category,
      sub_category: productDetails.sub_category,
      selected_product: productDetails.selected_product,
      size: '',
      listprice: '',
      moq: '',
      Quantity: '',
      hsncode: '',
      gstrate: '',
      description: '',
      batch: '',
      productImage: null,
      techSpecs: null
    });
  };

  // Handle edit product
  const handleEditBatch = (index) => {
    const productToEdit = addedProducts[index];
    setProductDetails(productToEdit);
    setEditingIndex(index);
  };

  // Cancel edit
  const handleCancelEdit = () => {
    setEditingIndex(null);
    setProductDetails({
      main_category: productDetails.main_category,
      sub_category: productDetails.sub_category,
      selected_product: productDetails.selected_product,
      size: '',
      listprice: '',
      Quantity: '',
      moq: '',
      hsncode: '',
      gstrate: '',
      description: '',
      batch: '',
      productImage: null,
      techSpecs: null
    });
  };

  // Handle submit
const handleSubmit = () => {
  if (addedProducts.length === 0) {
    alert("Please add at least one product batch.");
    return;
  }

  const formData = new FormData();

  addedProducts.forEach((product, index) => {
    formData.append(`product_${index}_main_category`, product.main_category);
    formData.append(`product_${index}_sub_category`, product.sub_category);
    formData.append(`product_${index}_selected_product`, product.selected_product);
    formData.append(`product_${index}_size`, product.size);
    formData.append(`product_${index}_listprice`, product.listprice);
    formData.append(`product_${index}_moq`, product.moq);
    formData.append(`product_${index}_hsncode`, product.hsncode);
    formData.append(`product_${index}_Quantity`, product.Quantity);
    formData.append(`product_${index}_gstrate`, product.gstrate);
    formData.append(`product_${index}_description`, product.description);
    formData.append(`product_${index}_batch`, product.batch);

    if (product.productImage) {
      formData.append(`product_${index}_productImage`, product.productImage);
    }

    if (product.techSpecs) {
      formData.append(`product_${index}_techSpecs`, product.techSpecs);
    }
  });
setLoading(true);
  axios.post(`${baseURL}/api/products-main`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  .then(response => {
    alert("✅ Products added successfully.");
    localStorage.removeItem('product_batches');
    setAddedProducts([]);
  })
  .catch(error => {
    console.error("❌ Error adding products:", error);
    if (error.response) {
      alert(`Failed to add products: ${error.response.data.error || "Unknown server error"}`);
    } else {
      alert("Error: " + error.message);
    }
  }) .finally(() => {
      setLoading(false); // ⏹ stop loading
    });
};


  // Remove a product batch from the added list
  const handleRemoveBatch = (index) => {
    const updatedList = addedProducts.filter((_, i) => i !== index);
    setAddedProducts(updatedList);
    localStorage.setItem('product_batches', JSON.stringify(updatedList));
    
    // If we're removing the product being edited, cancel edit mode
    if (editingIndex === index) {
      setEditingIndex(null);
    }
  };

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="card p-4">
          <h3 className="mb-4">Add Product</h3>
          <Form>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Select Category</Form.Label>
                  <div className="d-flex">
                    <Form.Control as="select" name="main_category" value={productDetails.main_category} onChange={handleInputChange} required>
                      <option value="">Select Main Category</option>
                      {mainCategories.map(category => (
                        <option key={category.maincategory_id} value={category.maincategory_id}>
                          {category.maincategory_name}
                        </option>
                      ))}
                    </Form.Control>
                    <Button variant="outline-primary" className="ms-2" onClick={() => setShowCategoryModal(true)}>+</Button>
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Sub Category</Form.Label>
                  <div className="d-flex">
                    <Form.Control as="select" name="sub_category" value={productDetails.sub_category} onChange={handleInputChange} required>
                      <option value="">Select Sub Category</option>
                      {subCategories.map(subCategory => (
                        <option key={subCategory.subcategory_id} value={subCategory.subcategory_id}>
                          {subCategory.subcategory_name}
                        </option>
                      ))}
                    </Form.Control>
                    <Button variant="outline-primary" className="ms-2" onClick={() => setShowSubCategoryModal(true)}>+</Button>
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Product Name</Form.Label>
                  <div className="d-flex">
                    <Form.Control as="select" name="selected_product" value={productDetails.selected_product} onChange={handleInputChange} required>
                      <option value="">Select Product</option>
                      {products.map(product => (
                        <option key={product.product_id} value={product.product_id}>
                          {product.product_name}
                        </option>
                      ))}
                    </Form.Control>
                    <Button variant="outline-primary" className="ms-2" onClick={() => setShowProductModal(true)}>+</Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Model</Form.Label>
                  <Form.Control type="text" name="batch" value={productDetails.batch} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>List Price</Form.Label>
                  <Form.Control type="number" name="listprice" value={productDetails.listprice} onChange={handleInputChange} placeholder="Enter Price" required />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
                {/* <Col md={6}>
                <Form.Group>
                  <Form.Label>Size</Form.Label>
                  <Form.Control type="text" name="size" value={productDetails.size} onChange={handleInputChange} required />
                </Form.Group>
              </Col> */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label>HSN Code</Form.Label>
                  <Form.Control type="text" name="hsncode" value={productDetails.hsncode} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>MOQ</Form.Label>
                  <Form.Control type="number" name="moq" value={productDetails.moq} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Quantity</Form.Label>
                  <Form.Control type="number" name="Quantity" value={productDetails.Quantity} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Gst</Form.Label>
                  <Form.Control type="text" name="gstrate" value={productDetails.gstrate} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
            </Row>
            
           <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Size</Form.Label>
                  <Form.Control type="text" name="size" value={productDetails.size} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
                <Col md={6}>
               <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control type="text" name="description" value={productDetails.description} onChange={handleInputChange} required />
                </Form.Group>
                </Col>
            </Row>
            
            {/* New File Upload Fields */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Upload Product Image</Form.Label>
                  <Form.Control 
                    type="file" 
                    name="productImage" 
                    onChange={handleFileChange} 
                    accept=".jpg,.jpeg,.png,.gif" 
                  />
                  <Form.Text className="text-muted">
                    Accepted formats: JPG, JPEG, PNG, GIF
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Upload Technical Specifications</Form.Label>
                  <Form.Control 
                    type="file" 
                    name="techSpecs" 
                    onChange={handleFileChange} 
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" 
                  />
                  <Form.Text className="text-muted">
                    Accepted formats: JPG, JPEG, PNG, PDF, DOC, DOCX
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex mb-3">
              {editingIndex !== null ? (
                <>
                  <Button variant="outline-primary" className="me-2" onClick={handleAddBatch}>Update Batch</Button>
                  <Button variant="outline-secondary" onClick={handleCancelEdit}>Cancel</Button>
                </>
              ) : (
                <Button variant="outline-primary" className="me-2" onClick={handleAddBatch}>Add Batch</Button>
              )}
            </div>

            {/* Display Added Products */}
            <h5 className="mt-4">Added Products</h5>
            <Table bordered className="mt-2">
              <thead>
                <tr>
                  <th>Model</th>
                  <th>Size</th>
                  <th>Quantity</th>
                  <th>MOQ</th>
                  <th>HSN Code</th>
                  <th>GST Rate</th>
                  <th>Price</th>
                  <th>Image</th>
                  <th>Tech Specs</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {addedProducts.map((product, index) => (
                  <tr key={index}>
                    <td>{product.batch}</td>
                    <td>{product.size}</td>
                    <td>{product.Quantity}</td>
                    <td>{product.moq}</td>
                    <td>{product.hsncode}</td>
                    <td>{product.gstrate}</td>
                    <td>{product.listprice}</td>
                    <td>{product.productImage ? product.productImage.name : 'No image'}</td>
                    <td>{product.techSpecs ? product.techSpecs.name : 'No file'}</td>
                    <td>
                      <Button variant="info" className="me-2" onClick={() => handleEditBatch(index)}>Edit</Button>
                      <Button variant="danger" onClick={() => handleRemoveBatch(index)}>Remove</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* Footer Buttons */}
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" >Close</Button>
              <Button 
        variant="primary" 
        onClick={handleSubmit} 
        disabled={loading} // prevent double click
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Submitting...
          </>
        ) : (
          "Submit All Products"
        )}
      </Button>

            </div>
          </Form>
        </div>
      </div>

      {/* Modal for Adding Category */}
      <Modal show={showCategoryModal} onHide={() => setShowCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Main Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCategorySubmit}>
            <Form.Group controlId="newMainCategory">
              <Form.Label>Category Name</Form.Label>
              <Form.Control type="text" value={newMainCategory} onChange={(e) => setNewMainCategory(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" onClick={() => setShowCategoryModal(false)}>Close</Button>
              <Button variant="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal for Adding Subcategory */}
      <Modal show={showSubCategoryModal} onHide={() => setShowSubCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Sub Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubCategorySubmit}>
            <Form.Group controlId="newSubCategory">
              <Form.Label>Sub Category Name</Form.Label>
              <Form.Control type="text" value={newSubCategory} onChange={(e) => setNewSubCategory(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" onClick={() => setShowSubCategoryModal(false)}>Close</Button>
              <Button variant="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal for Adding Product */}
      <Modal show={showProductModal} onHide={() => setShowProductModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleProductNameSubmit}>
            <Form.Group controlId="newProduct">
              <Form.Label>Product Name</Form.Label>
              <Form.Control type="text" value={newProduct} onChange={(e) => setNewProduct(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" onClick={() => setShowProductModal(false)}>Close</Button>
              <Button variant="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddProductForm;